import { useCallback, useRef, useState } from 'react';
import { useDidMount } from './useDidMount';

const usePolling = () => {
  const [pollingInterval, setPollingInterval] = useState<number | undefined>(undefined);

  // We need the ref to keep track of the interval when we're unmounting.
  const pollingIntervalRef = useRef<number | undefined>(undefined);

  const stopPolling = useCallback(() => {
    if (typeof pollingIntervalRef.current === 'number') {
      clearInterval(pollingIntervalRef.current);
      setPollingInterval(undefined);
      pollingIntervalRef.current = undefined;
    }
  }, []);

  const startPolling = useCallback(
    (callback: CallableFunction, timeout: number) => {
      stopPolling();

      const interval = setInterval(callback, timeout);
      setPollingInterval(interval);
      pollingIntervalRef.current = interval;

      return interval;
    },
    [stopPolling]
  );

  // When unmounting the hook, stop the polling.
  useDidMount(() => () => stopPolling());

  return {
    startPolling,
    stopPolling,
    isPolling: typeof pollingInterval === 'number'
  };
};

export default usePolling;
